// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@keller/XDL/types";

export default {
    popover: 1260,
    datePicker: 1270,
    dynamicDropdown: 1280,
    stickyFooter: 1284,
    loadingOverlay: 1285,
    menu: 1280,
    drawer: 1290,
    modal: 1305,
    tabGroup: 400,
    toaster: 1600,
    floatingUi: 1500,
    tooltip: 1263,
    header: 1284,
    compactHeader: 1264,
    scrimMenu: 1260,
    styledOverlay: 500,
} as xBaseTheme["zIndex"];
